export default {"src":"/_next/static/media/hero_f_green.dcfd7749.svg","height":593,"width":373,"blurWidth":0,"blurHeight":0};